var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupchecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 15.985L29.84 11.8L30.35 6.265L24.935 5.035L22.1 0.25L17 2.44L11.9 0.25L9.065 5.035L3.65 6.25L4.16 11.8L0.5 15.985L4.16 20.17L3.65 25.72L9.065 26.95L11.9 31.75L17 29.545L22.1 31.735L24.935 26.95L30.35 25.72L29.84 20.185L33.5 15.985ZM27.575 18.205L26.735 19.18L26.855 20.455L27.125 23.38L24.275 24.025L23.015 24.31L22.355 25.42L20.87 27.94L18.2 26.785L17 26.275L15.815 26.785L13.145 27.94L11.66 25.435L11 24.325L9.74 24.04L6.89 23.395L7.16 20.455L7.28 19.18L6.44 18.205L4.505 16L6.44 13.78L7.28 12.805L7.145 11.515L6.875 8.605L9.725 7.96L10.985 7.675L11.645 6.565L13.13 4.045L15.8 5.2L17 5.71L18.185 5.2L20.855 4.045L22.34 6.565L23 7.675L24.26 7.96L27.11 8.605L26.84 11.53L26.72 12.805L27.56 13.78L29.495 15.985L27.575 18.205Z",
    fill: "#009FE3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1346 18.6251L10.6546 15.1301L8.43457 17.3651L14.1346 23.0801L25.1446 12.0401L22.9246 9.80505L14.1346 18.6251Z",
    fill: "#009FE3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupchecked);
export default __webpack_public_path__ + "static/media/Groupchecked.bcda1bc9b3d3b3375c80cd7d6ec5d99c.svg";
export { ForwardRef as ReactComponent };